import { i18n } from 'next-i18next';

import { faCalendar, faCalendarArrowUp, faCalendarCheck } from '@fortawesome/pro-solid-svg-icons';
import { DefaultTheme } from 'styled-components';

import { AvailableThemes, ITheme } from './types';

export const getTheme = (key: AvailableThemes, theme: DefaultTheme): ITheme => {
  const themes = {
    sent: {
      background: theme.colors.warning.color,
      label: String(i18n?.t('meetings:status.pending')),
      icon: faCalendarArrowUp,
    },
    invite: {
      background: theme.colors.blue03.color,
      label: String(i18n?.t('meetings:status.confirmed')),
      icon: faCalendarCheck,
    },
    received: {
      background: theme.colors.purple.color,
      label: '',
      icon: faCalendar,
    },
  };

  return themes[key];
};
